///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import General from "../new-bid/General";
import Timeline from "../new-bid/Timeline";
import Financials from "../new-bid/Financials";
import Attachments from "./Attachments";
import Accordion from "../form-controls/Accordion";
import messages from "../../helpers/messages";
import { division } from "../../helpers/types";
import BidFormat from "./BidFormat";

function BidInformation({
  bid,
  setBidState,
  handleModeSelection,
  setModeDetails,
  validationData,
  removeError,
  validateShipper,
  userDivision,
  disableFTLBid,
  disableIMDLBid
}) {
  return (
    <>
      {userDivision === division.coy && (
        <BidFormat
          bid={bid}
          setBidState={setBidState}
          disableFTLBid={disableFTLBid}
          disableIMDLBid={disableIMDLBid}
        />
      )}
      <Accordion title={messages.general.defaultMessage}>
        <General
          bid={bid}
          setBidState={setBidState}
          handleModeSelection={handleModeSelection}
          setModeDetails={setModeDetails}
          validationData={validationData}
          removeError={removeError}
          validateShipper={validateShipper}
          userOrBidDivision={userDivision}
        />
      </Accordion>
      <Accordion title={messages.timeline.defaultMessage}>
        <Timeline
          bid={bid}
          setBidState={setBidState}
          validationData={validationData}
          removeError={removeError}
          userOrBidDivision={userDivision}
        />
      </Accordion>
      <Accordion title={messages.financials.defaultMessage}>
        <Financials
          bid={bid}
          setBidState={setBidState}
          validationData={validationData}
          removeError={removeError}
          userOrBidDivision={userDivision}
        />
      </Accordion>
      <Accordion title={messages.attachments.defaultMessage}>
        <Attachments files={bid.files} setBidState={setBidState} />
      </Accordion>
    </>
  );
}

export default BidInformation;
